<template>
  <b-modal
    v-model="isVisible"
    hide-footer
    size="lg"
    @hidden="onHide"
  >

    <b-card>

      <div class="mb-1">
        <b>Paciente:</b> {{ paciente }}
      </div>


      <b-alert 
        variant="success" 
        show class="p-2"
      >
        <div class="row align-items-center">
          <h5 for="" class="mx-1">Estado de Revision:</h5>
          
          <v-select
            v-model="estadoRevision" 
            :options="estadoAtencionOpts"
            placeholder="Estado de la atención." 
            :reduce="option => option.value" 
            label="text"
            class="col-5"
            :disabled="!canComentar"
          />

          <b-button
            v-if="canComentar"
            class="ml-3"
            variant="success"
            @click="onChangeState(estadoRevision)"
          >
            Cambiar estado
          </b-button>

          <b-button
            v-if="!canComentar && estadoRevision === '2'"
            class="ml-3"
            variant="success"
            @click="onChangeState('3')"
          >
            Cambiar a Revisada
          </b-button>
        </div>

      </b-alert>

      <br>
      <hr>

      <div class="d-flex align-items-center justify-content-between mb-2">
        <h5>Comentarios de validación</h5>
        <b-button
          v-if="canComentar"
          class="" 
          variant="warning"
          @click="onEditComment()"
        >+ Comentario</b-button>
      </div>

      <div 
        class="row d-flex align-items-center comentario"
        v-for="comentario in allComentarios"
        :key="comentario.token"
      >

        <div class="col-8 px-0">

          <div class="pl-1">
            <b>Autor:</b>
            {{ comentario.usuarioCreador.username + " - " + comentario.usuarioCreador.firstName + " " + comentario.usuarioCreador.lastName }}
          </div>

          <div class="pl-1">
            <b>Fecha ultimo cambio:</b>
            {{ formatDateToDB(comentario.ultimoCambio) }}
          </div>

          <div class="pl-1">
            <b>Comentario:</b>
            {{ comentario.comentario }}
          </div>
        </div>

        <div class="col-2">
          <span v-if="comentario.estadoComentario === '1'" class="text-warning">
            {{ "Notificado" }}
          </span>

          <span v-if="comentario.estadoComentario === '2'" class="text-info">
            {{ "Visto" }}
          </span>

          <span v-if="comentario.estadoComentario === '3'" class="text-success">
            {{ "Terminado" }}
          </span>
        </div>


        <div class="col-2 d-flex px-0">

          <b-button 
            v-if="canComentar && comentario.estadoComentario !== '1'"
            variant="warning" 
            size="sm"
            title="Notificar comentario"
            @click="onCambioEstadoComentario(comentario, '1')"
          >
            <i class="fa-solid fa-bell"/>
          </b-button>

          <b-button 
            v-if="canViewComentarios &&comentario.estadoComentario === '1'"
            size="sm"
            title="Cambiar a atendido"
            @click="onCambioEstadoComentario(comentario, '2')"
          >
            <i class="fa-solid fa-eye"/>
          </b-button>

          <!-- <b-button 
            v-if="canComentar && comentario.estadoComentario !== '3'"
            variant="success" 
            size="sm"
            title="Cambiar a terminado"
            @click="onCambioEstadoComentario(comentario, '3')"
          >
            <i class="fa-solid fa-check"/>
          </b-button> -->

          <b-button
            v-if="canEditComentario(comentario.usuarioCreador.username)"
            title="Editar comentario"
            size="sm"
            variant="info"
            @click="onEditComment(comentario)"
          >
            <i class="fas fa-edit"/>
          </b-button>

        </div>

      </div>
      

      <EmptyResults
        v-if="allComentarios && !allComentarios.length"
        message="No existen comentarios"
      />

      <b-modal
        v-if="comentarioToEdit"
        class="mt-3" 
        v-model="showEditComentario"
        hide-footer
      >
        <h5  class="text-center mb-2">
          {{  comentarioToEdit.token ? 'Editar comentario' : 'Nuevo comentario' }}
        </h5>
        
        <b-form-textarea
          v-model="comentarioToEdit.comentario"
          placeholder="Comentario de validacion"
          rows="3"
          max-rows="6"
        />
        

        <div class="text-right my-2">
          <b-button 
            variant="primary" 
            @click="onSaveComentario(comentarioToEdit)"
          >
            Guardar
          </b-button>
        </div>
      </b-modal> 

    </b-card>
    
  </b-modal>
</template>

<script>
import { EmptyResults } from '@/shared/components';
import vSelect from "vue-select";
import { formatDateToDB, comprobarRoles, getItemByValueId, getUserNameLS } from '@/shared/helpers';
import { ROLES } from '@/shared/constants';
import { citasService } from '../../services';
import { citasValidacionesService } from '../../services/citasValidacionesService';

export default {
  name: "AtencionValidacionComentario",

  components: {
    EmptyResults,
    vSelect
  },

  data() {
    return {

      paciente: null,

      estadoRevision: null,

      isVisible: false,
      tokenCita:null,
      comentarios:null,
      onlyView: false,

      comentarioOfUser: null,
      comentariosOthersUsers: null,
      allComentarios:null,

      comentarioValidacion: null,
      showEditComentario: false,
      comentarioToEdit: null,

      estadoComentarioOpts:[
        { value:'1', text:'Notificar' },
        { value:'2', text:'Visto' },
        { value:'3', text:'Terminado' },
      ],


      estadoAtencionOpts: [
        { value: '1', text: 'Creada' },
        { value: '2', text: 'Por revisar' },
        { value: '3', text: 'Revisada' },
        { value: '4', text: 'Concluida' }, 
        { value: '5', text: 'Anulada' },  
        { value: '6', text: 'Auditada' } 
      ],

      estadoValidacion:'1',

      formatDateToDB: formatDateToDB
    }
  },

  created() {
    this.onGetDataComments();
  },

  methods: {

    async onGetDataComments( ){
      this.tokenCita = this.$route.query.validator;
      if(!this.tokenCita) return;

      const citaResponse = await citasService.getByToken(this.tokenCita);

      if(!citaResponse){
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo obtener la cita'
        });

        return;
      }

      const dataPaciente = citaResponse?.paciente.persona;
      this.paciente = `${dataPaciente.identificacion} - ${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`;
      this.estadoRevision = citaResponse?.estadoRevision;
      // const dataPaciente = estadoRevisionResponse?.cita.paciente.persona;
      // this.paciente = `${dataPaciente.identificacion} - ${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`;
      // this.estadoRevision = estadoRevisionResponse?.estadoRev;

      this.isVisible = true;

      const responseComentarios = await citasValidacionesService.getComentariosValidacion(this.tokenCita);

      if (!responseComentarios || !responseComentarios.length){
        this.allComentarios = [];
        this.comentarioOfUser = { token: null, comentario: '', estadoComentario: null };
        this.isVisible = true;
        return;
      }

      this.allComentarios = responseComentarios;
      console.log('this.allComentarios', this.allComentarios);
    },


    onHide() {
      this.comentarioOfUser = null;
      this.comentariosOthersUsers = null;
      this.isVisible = false;
      this.comentarios = null;
    },


    onEditComment(comentarioToEdit){

      this.showEditComentario = true;

      if(!comentarioToEdit){
        this.comentarioToEdit = {}; 
        return;
      }

      this.comentarioToEdit = {
        ...comentarioToEdit, 
        estadoComentario: getItemByValueId(this.estadoComentarioOpts, comentarioToEdit.estadoComentario)
      } 

    },


    async onSaveComentario(comentario){
      // const response = await atencionAuditoriaService.updateComentarioValidacion(this.tokenAtencion, this.comentarioOfUser );
      const response = await citasValidacionesService.updateComentarioValidacion(this.tokenCita, comentario );

      if(!response) return;

      await this.$swal("Comentario de validación guardada.", "", "success")
      this.showEditComentario = false;

      this.$router.go(0);
    },


    canEditComentario(usuarioCreador){
      const usuarioEnSesion = getUserNameLS(); 
      return (usuarioCreador === usuarioEnSesion)
    },


    async onChangeState(estadoRevision){
      const responseUpdateState = await citasService.updateByToken(this.tokenCita, { estadoRevision });

      if (!responseUpdateState){
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'No se ha podido actualizar el estado de la atención',
        });

        return;
      }

      await this.$swal({
        icon: 'success',
        title: 'Éxito',
        text: 'Cambio de estado realizado correctamente',
      });

      this.$router.go(0);
    },



    async onCambioEstadoComentario(comentario, estado){

      if(!comentario || !estado) return;

      const result = await this.$swal({
        title: "¿Deseas cambiar el estado?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, cambiar",
        cancelButtonText: "No, cancelar"
      })

      if(!result.isConfirmed) return;

      const comentarioChangeState = {
        ...comentario,
        estado: estado
      }

      const response = await citasValidacionesService.updateComentarioValidacion(this.tokenCita, comentarioChangeState );

      if(!response) {
        this.$swal("Error", "No se pudo cambiar el estado.", "error");
        return;
      }

      await this.$swal("Comentario de validación guardada.", "", "success")
      this.isVisible = false;
    }

  },


  computed: {
    canViewComentarios(){
      return comprobarRoles([ROLES.ADMISION, ROLES.JEFE_MEDICO]);
    },
    
    canComentar(){
      return comprobarRoles([ROLES.JEFE_VALIDACIONES, ROLES.DIGITADOR]);
    }
  },

    

  watch: {

    '$route.query.validator': {
      handler(){
        this.onGetDataComments();
      },
    },


    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery.validator;
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }
  }

}
</script>

<style>
  .comentario{
    border-radius: 5px; 
    border: 1px solid #0080C9; 
    padding:10px 5px; 
    margin-bottom: 15px;
  }
</style>